import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-75bff351"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "main"
};
var _hoisted_2 = {
  class: "es-title"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "es-title__label"
  }, " Enterprise Suite ", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Banner = _resolveComponent("Banner");
  var _component_w_text_input = _resolveComponent("w-text-input");
  var _component_el_form_item = _resolveComponent("el-form-item");
  var _component_w_icon = _resolveComponent("w-icon");
  var _component_w_standard_button = _resolveComponent("w-standard-button");
  var _component_el_form = _resolveComponent("el-form");
  var _component_CenterCenter = _resolveComponent("CenterCenter");
  return _openBlock(), _createBlock(_component_CenterCenter, {
    logo: require('@/assets/theme/user_connect.png')
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: require('@/assets/logo-mini-black.svg'),
        class: "es-title__logo",
        alt: ""
      }, null, 8, _hoisted_3), _hoisted_4]), !!_ctx.errorMsg ? (_openBlock(), _createBlock(_component_Banner, {
        key: 0,
        type: "error"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.errorMsg), 1)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_form, {
        model: _ctx.loginForm,
        class: "login-form"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            class: "user-name-form-item",
            prop: "username",
            rules: [{
              required: true,
              trigger: 'blur',
              message: _ctx.$t('login.form.login_required_msg')
            }]
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_w_text_input, {
                "field-label": _ctx.$t('login.form.login_field_label'),
                width: "500px",
                value: _ctx.loginForm.username,
                size: "large",
                onInputChanged: _ctx.updateUserName
              }, null, 8, ["field-label", "value", "onInputChanged"])];
            }),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            prop: "password",
            rules: [{
              required: true,
              trigger: 'blur',
              message: _ctx.$t('login.form.password_required_msg')
            }]
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_w_text_input, {
                "field-label": _ctx.$t('login.form.password_field_label'),
                width: "500px",
                type: "password",
                "show-password": true,
                "custom-class": "password-input",
                onEnterPressed: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.login();
                }),
                size: "large",
                onInputChanged: _ctx.updatePassword
              }, null, 8, ["field-label", "onInputChanged"])];
            }),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            class: "login-form__submit-item"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_w_standard_button, {
                type: "primary",
                minWidth: "117px",
                disabled: _ctx.requiredFieldIsMissing(),
                "is-loading": _ctx.loading,
                class: "login-submit-btn",
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.login();
                })
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("span", null, _toDisplayString(_ctx.$t('login.form.submit_btn_label')), 1), _createVNode(_component_w_icon, {
                    icon: "login"
                  })];
                }),
                _: 1
              }, 8, ["disabled", "is-loading"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["model"])])];
    }),
    _: 1
  }, 8, ["logo"]);
}